module.exports = __webpack_public_path__ + "static/media/winter_contrast.d1185d98.jpg";